import { Injectable } from "@angular/core";
import { RiskRegisterViewMode } from "src/app/enums/riskRegisterViewMode.enum";

@Injectable({
    providedIn: "root",
})
export class SessionPreferencesService {
    // Retains the original storage key so a previously stored boolean preference
    // migrates transparently to the new three-value view mode.
    private readonly RISK_REGISTER_VIEW_MODE_KEY = "risk-register-use-health-risk-coloring";

    constructor() {}

    /**
     * Get the Risk Register grid view mode from sessionStorage.
     * Migrates the legacy boolean coloring preference: "true" → Health Risk,
     * "false" → Exposure Band. Defaults to Health Risk when nothing is stored,
     * matching the previous default behaviour.
     */
    getRiskRegisterViewMode(): RiskRegisterViewMode {
        const stored = sessionStorage.getItem(this.RISK_REGISTER_VIEW_MODE_KEY);

        if (
            stored === RiskRegisterViewMode.ExposureBand ||
            stored === RiskRegisterViewMode.Likelihood ||
            stored === RiskRegisterViewMode.HealthRisk
        ) {
            return stored;
        }

        if (stored === "false") {
            return RiskRegisterViewMode.ExposureBand;
        }

        return RiskRegisterViewMode.HealthRisk;
    }

    /**
     * Set the Risk Register grid view mode in sessionStorage.
     */
    setRiskRegisterViewMode(mode: RiskRegisterViewMode): void {
        const allowed = Object.values(RiskRegisterViewMode) as string[];
        if (!allowed.includes(mode)) {
            return;
        }
        sessionStorage.setItem(this.RISK_REGISTER_VIEW_MODE_KEY, mode);
    }
}
